<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="9">
                    <v-card class="mg-form__preview">
                        <v-card-title>Form Preview</v-card-title>
                        <draggable
                            id="preview"
                            v-model="formElements"
                            draggable=".item"
                            handle=".drag-area"
                            direction="vertical"
                            group="element"
                            :move="onMoveCallback"
                            :setData="setData"
                            :animation="300"
                            @change="log"
                            @start="onStart"
                            @add="onAdd"
                            @remove="onRemove"
                            @update="onUpdate"
                            @end="onEnd"
                            @choose="onChoose"
                            @unchoose="onUnchoose"
                            @sort="onSort"
                            @filter="onFilter"
                            @clone="onClone"
                        >
                            <div
                                class="mg-form__control mg-form__builder item"
                                v-for="(element, index) in formElements"
                                :key="index"
                                @drag="onDragging"
                            >
                                <div class="text-center mg-form__settings">
                                    <v-icon class="drag-area">mdi-drag-horizontal</v-icon>
                                </div>
                                <div
                                    class="mg-form__label body-2 font-weight-bold"
                                >{{ element.label }}</div>
                                <v-text-field outlined dense hide-details></v-text-field>
                            </div>
                        </draggable>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card>
                        <v-list>
                            <v-subheader>Form Fields</v-subheader>
                            <v-list-item-group color="primary">
                                <draggable
                                    v-model="formElementChoices"
                                    :sort="false"
                                    :group="{ name: 'element', pull: 'clone', put: false }"
                                    draggable=".item"
                                >
                                    <v-list-item
                                        class="item"
                                        :ripple="false"
                                        v-for="(element, index) in formElementChoices"
                                        :key="index"
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-form-select</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Open ended</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </draggable>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    components: {
        draggable
    },
    data: () => ({
        dragging: false,
        formElements: [
            {
                type: "textfield",
                label: "Label A"
            },
            {
                type: "textfield",
                label: "Label B"
            }
        ],
        formElementChoices: [
            {
                type: "textfield",
                label: "New Label 1"
            },
            {
                type: "textarea",
                label: "New Label 2"
            }
        ]
    }),
    methods: {
        setData: function(dataTransfer, element) {
            console.log("-- setData --");
            console.log(dataTransfer);
            // create an empty <span>
            // var dragGhost = {};
            // dragGhost = element.cloneNode(true);
            // // dragGhost = document.createElement('span');

            // // set its style so it'll be effectively (but not technically) invisible and
            // // won't change document flow
            // dragGhost.setAttribute('style', 'opacity: 0;' );

            // // add it to the document
            // // this.$refs.preview.$children.push(dragGhost)
            // this.$refs.preview.appendChild(dragGhost);
            // document.getElementById("preview").appendChild(dragGhost);
            var img = new Image();
            img.src =
                "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";
            dataTransfer.setDragImage(img, 0, 0);
        },
        onDragging: function(evt, originalEvent) {
            console.log("-- Dragging --");
            console.log(evt.clientX);
            console.log(evt.screenX);
            console.log(evt.x);
        },
        onMoveCallback: function(evt, originalEvent) {
            console.log("-- Move --");
            console.log(evt);
        },
        onStart: function(evt, originalEvent) {
            console.log("-- Start --");
            // this.dragging = true;
            // console.log(evt);
        },
        onAdd: function(evt, originalEvent) {
            console.log("-- Add --");
            // console.log(this.formElements);
            // console.log(this.formElementChoices);
        },
        onRemove: function(evt, originalEvent) {
            console.log("-- Remove --");
        },
        onUpdate: function(evt, originalEvent) {
            console.log("-- Update --");
        },
        onEnd: function(evt, originalEvent) {
            console.log("-- End --");
            // this.dragging = false;
            // console.log(evt);
        },
        onChoose: function(evt, originalEvent) {
            console.log("-- Choose --");
            // console.log(evt)
            // evt.item.style.backgroundColor = "#595957"
        },
        onUnchoose: function(evt, originalEvent) {
            console.log("-- Unchoose --");
        },
        onSort: function(evt, originalEvent) {
            console.log("-- Sort --");
        },
        onFilter: function(evt, originalEvent) {
            console.log("-- Filter --");
        },
        onClone: function(evt, originalEvent) {
            console.log("-- Clone --");
            // console.log(evt)
            // evt.clone.style.backgroundColor = "#595957"
        },
        onAdded: function(evt, originalEvent) {
            console.log("-- Added --");
            // console.log(this.formElements);
            // console.log(this.formElementChoices);
        },
        log: function(evt) {
            console.log(evt);
        }
    }
};
</script>

<style scoped>
.mg-form__preview.v-card {
    /* overflow: auto; */
}
.mg-form__control {
    position: relative;
    /* margin: 0 16px; */
    padding: 18px;
    padding-right: 26px;
}

.mg-form__control.mg-form__builder {
    background-color: white;
}

.mg-form__control .mg-form__settings {
}

.mg-form__control.mg-form__builder >>> .drag-area {
    cursor: grab;
}
.mg-form__control >>> .mg-form__label {
    margin: 0 auto;
    padding: 4px;
}

.mg-form__preview.v-card .item.sortable-ghost {
    /* padding: 18px;
  margin-bottom: 16px;
  height: 100px;
  border: grey 1px dotted; */
    transform: scale(1.02) !important;
    z-index: 99;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
        0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.mg-form__control.sortable-ghost * {
    /* display: none; */
}

/* .mg-form__control.mg-form__builder.sortable-chosen >>> .drag-area {
    cursor: grabbing;
} */
</style>
